var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"d-flex flex-column"},[_c('packet-creator',{attrs:{"organization-id":_vm.organizationId},on:{"created":_vm.finishUp,"find-base-packet":_vm.findBasePacket}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }